import React from "react";
import '../App.css';
import '../blocks/customblocks';
import '../generator/generator';
import BlocklyComponent from '../Blockly';
import styles from "../styles/level1.module.css"
import level0instr from "../images/level0/level0instr.png"
import instrLink from "../images/level0/instrLink.png"
import level0Task0 from '../solutionxml/level0Task0'
import fulltoolbox from '../toolboxes/fulltoolbox';
import level5xml from '../solutionxml/level5xml'

const playground = () => {
  return (
    <div className={styles.container}>
    <main>
      <h1 className={styles.title}>
        Playground 
      </h1>
      <br></br>
    <div>
      <BlocklyComponent readOnly={false} 
      trashcan={true} media={'media/'}
      move={{
        scrollbars: true,
        drag: true,
        wheel: true
      }}
      toolbox={fulltoolbox}
      solutionXml={level5xml}>
    </BlocklyComponent>
  </div>
  </main>
  </div>
  );
}
  
export default playground;